import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { Http } from "@status/codes";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import {
  FORM_TEMPLATES_ACCESS,
  FORM_TEMP_CONSTANTS
} from "@/modules/FormTemplate/constants/FormTemplateConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FormSchema } from "@/shared/models/FormSchema";
import FormRulePreview from "@/shared/components/FormModalViewer/FormRulePreview/FormRulePreview.vue";
import FormSummaryPreview from "@/shared/components/FormModalViewer/FormSummaryPreview/FormSummaryPreview.vue";
import vueDebounce from "vue-debounce";
import { FormsData } from "@/modules/Forms/models/FormsData";
import { FormsService } from "@/modules/Forms/services/FormService";
import {
  FORMS_ACCESS,
  FORMS_CONSTANTS
} from "@/modules/Forms/constants/FormsConstants";
import { QuerySearch } from "@/modules/Forms/models/QuerySearch";
import { TaskDTO } from "@/modules/Tasks/models/TaskDTO";
import { AxiosError } from "axios";

Vue.use(vueDebounce, {
  defaultTime: "2000ms",
  listenTo: ["input", "click"]
});

@Component({
  name: "Tasks",
  components: {
    ModifVJsfInput,
    FormRulePreview,
    FormSummaryPreview
  }
})
export default class Tasks extends Vue {
  @Prop() private task!: TaskDTO;

  @Inject() formsService!: FormsService;
  @Inject() formTemplateService!: FormTemplateService;

  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  refresh = 0;
  modelChanged = false;
  dialog = false;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  model: any = {};
  formData!: FormsData;
  dataForm = true;
  formulaValue = "";
  formRules: FormRule[] = [];
  formSummary: FieldSummary[] = [];

  STATUS_TEXT = "";

  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  selectedBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  async mounted() {
    this.STATUS_TEXT = this.task.form.status;
    await this.openForm();
  }

  async openForm() {
    await this.getFormTemplatePreviewData(this.task.formTemplate);

    const loadData =
      this.STATUS_TEXT === FORMS_CONSTANTS.PENDING_TEXT ? false : true;

    const query: QuerySearch = {
      taskId: this.task.id,
      formTemplateId: this.task.formTemplate,
      loadData: loadData
    };

    if (loadData === true) {
      query.versionTemplate = this.task.form.versionTemplate;
    }

    try {
      const form = await this.formsService.formInformation(query);

      if (form.code == Http.Found && form.data) {
        this.formData = form.data;

        if (this.formData.form) {
          this.model = Object.assign({}, this.formData.form.fields);
          this.refresh = 1 - this.refresh;
        }
      } else {
        this.dialog = false;
        Snackbar.popError(FORMS_CONSTANTS.SNACKBAR_MSG.ERROR_LOAD);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplatePreviewData(id: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );

      if (response.code === Http.Found && response.data != null) {
        const responseData = response.data;

        this.schema = responseData.schema;
        this.formSummary = responseData.formSummary;
        this.formRules = responseData.formRules;

        Snackbar.popInfo(response.message);

        this.setSchemaReadOnly();
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  reloadData() {
    const items = this.schema.fields ? this.schema.fields : [];
    const conditions = this.schema.conditions ? this.schema.conditions : [];

    items.forEach(field => {
      if (
        field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA &&
        field.formula
      ) {
        this.formulaValue = field.formula.repeat(1);
        let fields = this.formulaValue.match(/\b[0-9A-Za-z_.-]{10}\b/g);

        if (fields != null) {
          const uniqueSet = new Set(fields);
          fields = [...uniqueSet];

          fields.forEach(fieldString => {
            if (fieldString in this.model) {
              let newValue = "";
              let score;

              const existList = items.find(
                item =>
                  item.key === fieldString &&
                  item.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST
              );

              if (existList != undefined) {
                if (existList.options) {
                  score = existList.options.find(
                    item => item.value === this.model[fieldString]
                  )?.score;
                } else {
                  score = existList.schema.oneOf?.find(
                    item => item.const === this.model[fieldString]
                  )?.score;
                }
              }
              if ((score && Number(score)) || score == 0) {
                newValue = score.toString();
              } else {
                newValue = this.model[fieldString];
              }
              const regExp = new RegExp(fieldString, "g");
              this.formulaValue = this.formulaValue.replace(
                regExp,
                `${newValue}`
              );
            }
          });

          try {
            const result = eval(this.formulaValue);
            if (result && isFinite(result)) {
              Vue.set(this.model, field.key, result.toString());
              this.modelChanged = true;
            }
          } catch (e) {
            delete this.model[field.key];
          }
        }
      }
    });
    conditions.forEach(condition => {
      if (condition.isArray && this.model[condition.key] != undefined) {
        this.model[condition.key].sort();
        this.modelChanged = true;
      }
    });

    if (this.modelChanged) {
      this.modelChanged = false;
    }
  }

  setSchemaReadOnly() {
    this.schema.allOf.forEach(field => {
      const keys = Object.keys(field["properties"]);
      field["properties"][keys[0]].readOnly = true;
      field["properties"][keys[0]]["x-style"] = STYLE_CLASSES.FORMULA;
      if (field["then"]) {
        const keys = Object.keys(field["then"]["properties"]);
        keys.forEach(key => {
          if (field["then"]) {
            field["then"]["properties"][key].readOnly = true;
            field["then"]["properties"][key]["x-style"] = STYLE_CLASSES.FORMULA;
          }
        });
      }
    });
  }
}
